import React from 'react';
import { Link } from 'react-router-dom';
import { learnArticlePath, learnHubPath, readyLearnLangs } from './learnData';

const LearnLanguageNav = ({ lang, slug }) => {
  const langs = readyLearnLangs();
  if (langs.length < 2) return null;
  return (
    <nav className="lt-langs" aria-label="Languages">
      {langs.map((item) => (
        <Link
          key={item.code}
          to={slug ? learnArticlePath(slug, item.code) : learnHubPath(item.code)}
          hrefLang={item.code}
          lang={item.code}
          aria-current={item.code === lang ? 'page' : undefined}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  );
};

export default LearnLanguageNav;
